/**
 * SystemMessage component.
 *
 * Renders centered, muted-color system messages such as
 * "A live agent has joined", "Session expired", etc.
 * Visually distinct from bot/user bubbles: no bubble shape,
 * centered text, muted styling.
 */

import type { ChatMessage } from "../../types";
import { formatTimestamp } from "./timestamp";

export interface SystemMessageOptions {
  message: ChatMessage;
}

export class SystemMessage {
  private readonly element: HTMLElement;

  constructor(options: SystemMessageOptions) {
    const { message } = options;

    this.element = document.createElement("div");
    this.element.className = "hana-system-msg";
    this.element.setAttribute("role", "status");
    this.element.setAttribute("data-message-id", message.id);

    const textEl = document.createElement("span");
    textEl.className = "hana-system-msg__text";
    textEl.textContent = message.content ?? "";
    this.element.appendChild(textEl);

    const timeEl = document.createElement("span");
    timeEl.className = "hana-system-msg__time";
    timeEl.setAttribute("data-message-timestamp", String(message.timestamp));
    timeEl.textContent = formatTimestamp(message.timestamp);
    this.element.appendChild(timeEl);
  }

  getElement(): HTMLElement {
    return this.element;
  }
}
